<div class="cm">

  <svg #svgRef
       [attr.viewBox]="'0 0 ' + SVG_W + ' ' + SVG_H"
       class="cm__svg"
       xmlns="http://www.w3.org/2000/svg">

    <defs>

      <!-- Gradient for completed track -->
      <linearGradient id="cm-done-grad" x1="0" y1="1" x2="0" y2="0" gradientUnits="objectBoundingBox">
        <stop offset="0%" stop-color="#3A82F6"/>
        <stop offset="100%" stop-color="#60A5FA"/>
      </linearGradient>

      <!-- Gradient for current node -->
      <linearGradient id="cm-current-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#60A5FA"/>
        <stop offset="100%" stop-color="#3A82F6"/>
      </linearGradient>

      <!-- Gradient for exam node (à passer) -->
      <linearGradient id="cm-exam-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#FBBF24"/>
        <stop offset="100%" stop-color="#F59E0B"/>
      </linearGradient>

      <!-- Flag clip paths for completed nodes -->
      <ng-container *ngFor="let s of sorted; let i = index; trackBy: trackByIndex">
        <clipPath [id]="'cm-fc-' + i" clipPathUnits="userSpaceOnUse">
          <circle
            [attr.cx]="nodePositions[i]?.x"
            [attr.cy]="nodePositions[i]?.y"
            [attr.r]="R - 2"/>
        </clipPath>
      </ng-container>

    </defs>

    <!-- Road base (white border underneath the track) -->
    <path [attr.d]="trackPath" class="cm__track cm__track--road"/>

    <!-- Background track -->
    <path [attr.d]="trackPath" class="cm__track"/>

    <!-- Completed track -->
    <path *ngIf="donePath" [attr.d]="donePath" class="cm__track cm__track--done"/>

    <!-- ── Decorative section assets — explicit placements from decor-config.json ── -->
    <g *ngIf="decorPlacements.length > 0" class="cm__decor-layer">
      <image *ngFor="let p of decorPlacements; trackBy: trackByIndex"
        [attr.href]="decorPlacementPath(p)"
        [attr.x]="decorPlacementPos(p).x"
        [attr.y]="decorPlacementPos(p).y"
        [attr.width]="decorPlacementSize(p)"
        [attr.height]="decorPlacementSize(p)"
        [attr.transform]="decorPlacementTransform(p)"
        class="cm__decor-img"
        preserveAspectRatio="xMidYMid meet"/>
    </g>

    <!-- ── Nodes ─────────────────────────────────── -->
    <g *ngFor="let s of sorted; let i = index; trackBy: trackByIndex"
       [id]="'cm-node-' + s.position"
       class="cm__node-g"
       [class.cm__node-g--clickable]="isItemUnlocked(s)"
       (click)="navigate(s)">

      <title>{{ s.name }}</title>

      <!-- ── Examen de fin de palier CEFRL (nœud distinctif) ── -->
      <ng-container *ngIf="isCefrlExam(s)">

        <!-- Carré arrondi, plus grand que les nœuds de cours -->
        <rect
          [attr.x]="nodePositions[i].x - RE"
          [attr.y]="nodePositions[i].y - RE"
          [attr.width]="RE * 2"
          [attr.height]="RE * 2"
          rx="16"
          class="cm__exam-rect"
          [class.cm__exam-rect--locked]="examState(s) === 'locked'"
          [class.cm__exam-rect--todo]="examState(s) === 'todo'"
          [class.cm__exam-rect--passed]="examState(s) === 'passed'"
          [class.cm__exam-rect--failed]="examState(s) === 'failed'"/>

        <!-- Coiffe de diplômé + palier CEFRL (délavés quand verrouillé) -->
        <path [attr.d]="examCapBasePath(nodePositions[i])"
          class="cm__exam-cap"
          [class.cm__exam-cap--locked]="examState(s) === 'locked'"
          [class.cm__exam-cap--todo]="examState(s) === 'todo'"
          [class.cm__exam-cap--passed]="examState(s) === 'passed'"
          [class.cm__exam-cap--failed]="examState(s) === 'failed'"/>
        <path [attr.d]="examCapBoardPath(nodePositions[i])"
          class="cm__exam-cap"
          [class.cm__exam-cap--locked]="examState(s) === 'locked'"
          [class.cm__exam-cap--todo]="examState(s) === 'todo'"
          [class.cm__exam-cap--passed]="examState(s) === 'passed'"
          [class.cm__exam-cap--failed]="examState(s) === 'failed'"/>
        <path [attr.d]="examCapTasselPath(nodePositions[i])"
          class="cm__exam-tassel"
          [class.cm__exam-tassel--locked]="examState(s) === 'locked'"
          [class.cm__exam-tassel--todo]="examState(s) === 'todo'"
          [class.cm__exam-tassel--passed]="examState(s) === 'passed'"
          [class.cm__exam-tassel--failed]="examState(s) === 'failed'"/>
        <circle
          [attr.cx]="examCapTasselEnd(nodePositions[i]).x"
          [attr.cy]="examCapTasselEnd(nodePositions[i]).y"
          [attr.r]="RE * 0.09"
          class="cm__exam-cap"
          [class.cm__exam-cap--locked]="examState(s) === 'locked'"
          [class.cm__exam-cap--todo]="examState(s) === 'todo'"
          [class.cm__exam-cap--passed]="examState(s) === 'passed'"
          [class.cm__exam-cap--failed]="examState(s) === 'failed'"/>
        <text
          [attr.x]="nodePositions[i].x"
          [attr.y]="nodePositions[i].y + RE * 0.45"
          class="cm__exam-cefrl"
          [class.cm__exam-cefrl--locked]="examState(s) === 'locked'"
          [class.cm__exam-cefrl--todo]="examState(s) === 'todo'"
          [class.cm__exam-cefrl--passed]="examState(s) === 'passed'"
          [class.cm__exam-cefrl--failed]="examState(s) === 'failed'">{{ s.cefrl }}</text>

        <!-- Verrouillé : badge cadenas au coin -->
        <ng-container *ngIf="examState(s) === 'locked'">
          <circle [attr.cx]="nodePositions[i].x + RE - 4" [attr.cy]="nodePositions[i].y - RE + 4" r="11" class="cm__check-bg"/>
          <circle [attr.cx]="nodePositions[i].x + RE - 4" [attr.cy]="nodePositions[i].y - RE + 4" r="9"  class="cm__exam-lock-badge"/>
          <path [attr.d]="examLockBadgeShacklePath(nodePositions[i])" class="cm__exam-lock-badge-shackle"/>
          <rect
            [attr.x]="nodePositions[i].x + RE - 8"
            [attr.y]="nodePositions[i].y - RE + 3.5"
            width="8" height="6" rx="1.5"
            class="cm__exam-lock-badge-body"/>
        </ng-container>

        <!-- Badge réussi (coin) -->
        <ng-container *ngIf="examState(s) === 'passed'">
          <circle [attr.cx]="nodePositions[i].x + RE - 4" [attr.cy]="nodePositions[i].y - RE + 4" r="11" class="cm__check-bg"/>
          <circle [attr.cx]="nodePositions[i].x + RE - 4" [attr.cy]="nodePositions[i].y - RE + 4" r="9"  class="cm__check-fill"/>
          <path [attr.d]="checkPath(nodePositions[i], RE)" class="cm__check-mark"/>
        </ng-container>

        <!-- Badge raté (coin) -->
        <ng-container *ngIf="examState(s) === 'failed'">
          <circle [attr.cx]="nodePositions[i].x + RE - 4" [attr.cy]="nodePositions[i].y - RE + 4" r="11" class="cm__check-bg"/>
          <circle [attr.cx]="nodePositions[i].x + RE - 4" [attr.cy]="nodePositions[i].y - RE + 4" r="9"  class="cm__exam-cross-fill"/>
          <path [attr.d]="crossPath(nodePositions[i], RE)" class="cm__check-mark"/>
        </ng-container>

        <!-- Pastille meilleur score (bord bas) -->
        <ng-container *ngIf="examState(s) === 'passed' || examState(s) === 'failed'">
          <rect
            [attr.x]="nodePositions[i].x - 19"
            [attr.y]="nodePositions[i].y + RE - 9"
            width="38" height="18" rx="9"
            class="cm__exam-score-pill"
            [class.cm__exam-score-pill--passed]="examState(s) === 'passed'"
            [class.cm__exam-score-pill--failed]="examState(s) === 'failed'"/>
          <text
            [attr.x]="nodePositions[i].x"
            [attr.y]="nodePositions[i].y + RE"
            class="cm__score-badge">{{ itemScore(s) }}%</text>
        </ng-container>

      </ng-container>

      <ng-container *ngIf="!isCefrlExam(s)">

      <!-- LOCKED -->
      <ng-container *ngIf="state(s) === 'locked'">
        <circle
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y"
          [attr.r]="R"
          class="cm__circle cm__circle--locked"/>
        <path
          [attr.d]="lockPath(nodePositions[i].x, nodePositions[i].y)"
          class="cm__lock-shackle"/>
        <rect
          [attr.x]="nodePositions[i].x - 8"
          [attr.y]="nodePositions[i].y - 2"
          width="16" height="12" rx="3"
          class="cm__lock-body"/>
        <circle
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y + 2"
          r="3"
          class="cm__lock-hole"/>
        <rect
          [attr.x]="nodePositions[i].x - 1.5"
          [attr.y]="nodePositions[i].y + 3.5"
          width="3" height="4" rx="1.5"
          class="cm__lock-hole"/>
      </ng-container>

      <!-- UNLOCKED -->
      <ng-container *ngIf="state(s) === 'unlocked'">
        <!-- Progress ring track (mode levels) -->
        <circle *ngIf="mode === 'levels' && itemScore(s) > 0"
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y"
          [attr.r]="R + 5"
          class="cm__progress-track"/>
        <!-- Progress ring fill (mode levels) -->
        <circle *ngIf="mode === 'levels' && itemScore(s) > 0"
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y"
          [attr.r]="R + 5"
          class="cm__progress-fill"
          [attr.stroke-dasharray]="progressDash(s)"
          [attr.transform]="progressRotate(nodePositions[i])"/>
        <circle
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y"
          [attr.r]="R"
          class="cm__circle cm__circle--unlocked"/>
        <!-- Score % in levels mode when in progress, position number otherwise -->
        <text *ngIf="mode === 'levels' && itemScore(s) > 0"
          [attr.x]="nodePositions[i].x"
          [attr.y]="nodePositions[i].y"
          class="cm__node-score">{{ itemScore(s) }}%</text>
        <text *ngIf="mode !== 'levels' || itemScore(s) === 0"
          [attr.x]="nodePositions[i].x"
          [attr.y]="nodePositions[i].y"
          class="cm__node-num">{{ s.position !== null ? s.position + 1 : i + 1 }}</text>
      </ng-container>

      <!-- CURRENT -->
      <ng-container *ngIf="state(s) === 'current'">
        <!-- Outer static ring -->
        <circle
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y"
          [attr.r]="R + 10"
          class="cm__current-ring"/>
        <!-- Main filled circle -->
        <circle
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y"
          [attr.r]="R + 2"
          class="cm__circle cm__circle--current"/>
        <!-- Play icon -->
        <path [attr.d]="playPath(nodePositions[i])" class="cm__play-icon"/>
      </ng-container>

      <!-- COMPLETED -->
      <ng-container *ngIf="state(s) === 'completed'">
        <image
          [attr.href]="flagPath"
          [attr.x]="nodePositions[i].x - (R - 2)"
          [attr.y]="nodePositions[i].y - (R - 2)"
          [attr.width]="(R - 2) * 2"
          [attr.height]="(R - 2) * 2"
          [attr.clip-path]="'url(#cm-fc-' + i + ')'"
          preserveAspectRatio="xMidYMid slice"/>
        <circle
          [attr.cx]="nodePositions[i].x"
          [attr.cy]="nodePositions[i].y"
          [attr.r]="R"
          class="cm__circle--completed-ring"/>
        <!-- Score pill badge (mode levels) -->
        <ng-container *ngIf="mode === 'levels'">
          <rect
            [attr.x]="nodePositions[i].x + R - 23"
            [attr.y]="nodePositions[i].y - R - 9"
            width="38" height="18" rx="9"
            class="cm__score-pill"/>
          <text
            [attr.x]="nodePositions[i].x + R - 4"
            [attr.y]="nodePositions[i].y - R + 1"
            class="cm__score-badge">{{ itemScore(s) }}%</text>
        </ng-container>
        <ng-container *ngIf="mode !== 'levels'">
          <circle [attr.cx]="nodePositions[i].x + R - 4" [attr.cy]="nodePositions[i].y - R + 4" r="11" class="cm__check-bg"/>
          <circle [attr.cx]="nodePositions[i].x + R - 4" [attr.cy]="nodePositions[i].y - R + 4" r="9"  class="cm__check-fill"/>
          <path [attr.d]="checkPath(nodePositions[i])" class="cm__check-mark"/>
        </ng-container>
      </ng-container>

      </ng-container>

      <!-- Section name label (les nœuds examen sont plus grands + pastille de score en bas) -->
      <text
        [attr.x]="nodePositions[i].x"
        [attr.y]="nodePositions[i].y + (isCefrlExam(s) ? RE + 20 : R + 18)"
        class="cm__node-label"
        [class.cm__node-label--current]="state(s) === 'current'"
        [class.cm__node-label--locked]="state(s) === 'locked'">{{ shortName(s) }}</text>

    </g>

  </svg>

</div>
